module.exports = __webpack_public_path__ + "static/media/imnot.b625ed05.svg";